import * as React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

// Interactive card — centralizes the "clickable card" pattern.
// Renders as <button> (action) or <Link> (navigation) depending on props.
// Provides consistent hover, focus-visible, transition, and border styles.

const baseStyles =
  'flex w-full items-center gap-3 rounded-lg border border-border bg-background px-3 py-3 text-left transition-colors hover:bg-accent/40 hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

type InteractiveCardProps = {
  children: React.ReactNode;
  className?: string;
} & (
  | { to: string; onClick?: never; type?: never; disabled?: never }
  | { to?: never; onClick: () => void; type?: 'button'; disabled?: boolean }
);

function InteractiveCard({ children, className, ...props }: InteractiveCardProps) {
  if ('to' in props && props.to) {
    return (
      <Link to={props.to} className={cn(baseStyles, 'no-underline', className)}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type={props.type ?? 'button'}
      onClick={props.onClick}
      disabled={props.disabled}
      className={cn(baseStyles, props.disabled && 'pointer-events-none opacity-50', className)}
    >
      {children}
    </button>
  );
}

export { InteractiveCard };
